// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.lunchtime div.header {
  margin: 0 auto;
  max-width: 1440px;
  height: 56px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
}
div.lunchtime div.header span.title {
  font-size: 32px;
  line-height: 32px;
  font-weight: bold;
  color: white;
  background-color: rgb(222, 41, 34);
  padding: 12px;
  box-sizing: border-box;
}
div.lunchtime div.header span.spacer {
  display: none;
}
div.lunchtime div.header span.subtitle {
  font-size: 24px;
  opacity: 0.7;
  flex-grow: 1;
  padding-left: 30px;
  padding-top: 5px;
}
div.lunchtime div.header span.user {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
div.lunchtime div.hero {
  max-width: 1440px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 40px 0;
  margin: 0 auto;
}
div.lunchtime div.hero div.step {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 33%;
  padding: 0 30px;
}
div.lunchtime div.hero div.step div.bubble {
  height: 180px;
  width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
}
div.lunchtime div.hero div.step div.bubble i.fa {
  color: rgb(222, 41, 34);
  font-size: 76px;
}
div.lunchtime div.hero div.step h2 {
  color: #444;
  margin: 0 0 6px 0;
  text-align: center;
}
div.lunchtime div.hero div.step article {
  text-align: center;
  width: 80%;
  color: rgba(0, 0, 0, 0.6);
  opacity: 0.8;
}
div.lunchtime div.dates {
  background-color: rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 60px 0;
}
div.lunchtime div.dates h1.date-title {
  color: #444;
  font-size: 40px;
  font-weight: 200;
  align-self: center;
  opacity: 0.8;
  margin: 0;
  padding: 0;
}
div.lunchtime div.dates h2.date-subtitle {
  font-weight: 100;
  margin: 0;
  margin-bottom: 40px;
  font-size: 22px;
  opacity: 0.6;
}
div.lunchtime div.dates div.appointments {
  display: flex;
  justify-content: center;
  align-items: center;
}
div.lunchtime div.dates div.appointments div.appointment {
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  height: 160px;
  width: 200px;
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding-bottom: 6px;
  background-color: white;
  position: relative;
}
div.lunchtime div.dates div.appointments div.appointment div.check {
  position: absolute;
  top: 39px;
  left: 0;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 30px 30px;
  height: 127px;
  width: 100%;
  opacity: 0;
}
div.lunchtime div.dates div.appointments div.appointment div.check span {
  color: black;
}
div.lunchtime div.dates div.appointments div.appointment div.check i.fa {
  font-size: 60px;
  line-height: 70px;
  color: rgb(107, 171, 45);
}
div.lunchtime div.dates div.appointments div.appointment span {
  font-size: 14px;
}
div.lunchtime div.dates div.appointments div.appointment div.day {
  display: inline;
  width: 100%;
  background-color: #444;
  color: white;
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  border-radius: 30px 30px 0 0;
}
div.lunchtime div.dates div.appointments div.appointment div.combined {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}
div.lunchtime div.dates div.appointments div.appointment div.combined span.big-number {
  color: #444;
  font-size: 44px;
  line-height: 44px;
  font-weight: bold;
}
div.lunchtime div.dates div.appointments div.appointment div.combined span.noon {
  opacity: 0.7;
}
div.lunchtime div.dates div.appointments div.appointment.selected {
  background-color: rgb(177, 198, 16);
  color: white;
}
div.lunchtime div.dates div.appointments div.appointment.selected div.combined span.big-number {
  color: white;
}
div.lunchtime div.dates div.appointments div.appointment.isLocked {
  opacity: 0.4;
  cursor: default;
}
div.lunchtime div.dates div.appointments div.appointment.isLocked:hover {
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);
}
div.lunchtime div.dates div.appointments div.appointment:hover {
  box-shadow: 0px 8px 14px 2px rgba(0, 0, 0, 0.1);
}
div.lunchtime div.suggestions {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  margin-bottom: 20px;
}
div.lunchtime div.suggestions h1 {
  color: #444;
  font-size: 40px;
  font-weight: 200;
  align-self: center;
  opacity: 0.8;
  width: 570px;
  text-align: center;
}
div.lunchtime div.suggestions button {
  align-self: center;
  cursor: pointer;
}
div.lunchtime div.footer {
  background-color: #444;
  color: white;
}
div.lunchtime div.footer div.links {
  width: 80%;
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
div.lunchtime div.footer div.links h2 {
  flex-grow: 1;
}
div.lunchtime div.footer div.links span {
  margin: 0 10px;
  opacity: 0.8;
  font-size: 12px;
  cursor: pointer;
}
div.lunchtime div.footer div.links span:hover {
  opacity: 1;
}

@media (max-width: 1024px), (orientation: portrait) {
  div.modal {
    display: none;
  }
  div.lunchtime div.header span.subtitle {
    display: none;
  }
  div.lunchtime div.header span.spacer {
    flex-grow: 1;
    display: flex;
  }
  div.lunchtime div.hero {
    display: none;
  }
  div.lunchtime div.dates {
    padding-bottom: 40px;
  }
  div.lunchtime div.dates div.appointments {
    flex-direction: column;
    justify-content: flex-start;
  }
  div.lunchtime div.dates div.appointments div.appointment {
    margin-bottom: 40px;
  }
  div.lunchtime div.suggestions {
    display: none;
  }
  div.lunchtime div.footer div.links span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGI;EACI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;AAFR;AAKY;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kCCVP;EDWO,aAAA;EACA,sBAAA;AAHhB;AAMY;EACI,aAAA;AAJhB;AAOY;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AALhB;AAQY;EACI,eAAA;EACA,yBCnCJ;AD6BZ;AAWI;EACI,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AATR;AAWQ;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AATZ;AAWY;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAThB;AAWgB;EACI,uBC1DX;ED2DW,eAAA;AATpB;AAaY;EACI,WCxEJ;EDyEI,iBAAA;EACA,kBAAA;AAXhB;AAcY;EACI,kBAAA;EACA,UAAA;EACA,yBC9EJ;ED+EI,YAAA;AAZhB;AAiBI;EACI,qCClFW;EDmFX,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AAfR;AAiBQ;EACI,WC/FA;EDgGA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAfZ;AAkBQ;EACI,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAhBZ;AAmBQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAjBZ;AAmBY;EACI,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAjBhB;AAmBgB;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AAjBpB;AAmBoB;EACI,YAAA;AAjBxB;AAoBoB;EACI,eAAA;EACA,iBAAA;EACA,wBC/IR;AD6HhB;AAsBgB;EACI,eAAA;AApBpB;AAuBgB;EACI,eAAA;EACA,WAAA;EACA,sBCnKR;EDoKQ,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AArBpB;AAwBgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAtBpB;AAwBoB;EACI,WCnLZ;EDoLY,eAAA;EACA,iBAAA;EACA,iBAAA;AAtBxB;AAyBoB;EACI,YAAA;AAvBxB;AA2BgB;EACI,mCCrLF;EDsLE,YAAA;AAzBpB;AA4BwB;EACI,YAAA;AA1B5B;AA+BgB;EACI,YAAA;EACA,eAAA;AA7BpB;AA+BoB;EACI,8CAAA;AA7BxB;AAiCgB;EACI,+CAAA;AA/BpB;AAqCI;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AAnCR;AAqCQ;EACI,WCjOA;EDkOA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAnCZ;AAsCQ;EACI,kBAAA;EACA,eAAA;AApCZ;AAwCI;EACI,sBCjPI;EDkPJ,YAAA;AAtCR;AAwCQ;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAtCZ;AAwCY;EACI,YAAA;AAtChB;AAyCY;EACI,cAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAvChB;AAyCgB;EACI,UAAA;AAvCpB;;AA8CA;EACI;IACI,aAAA;EA3CN;EAgDU;IACI,aAAA;EA9Cd;EAiDU;IACI,YAAA;IACA,aAAA;EA/Cd;EAmDM;IACI,aAAA;EAjDV;EAoDM;IACI,oBAAA;EAlDV;EAoDU;IACI,sBAAA;IACA,2BAAA;EAlDd;EAoDc;IACI,mBAAA;EAlDlB;EAuDM;IACI,aAAA;EArDV;EA0Dc;IACI,aAAA;EAxDlB;AACF","sourcesContent":["@use 'colors' as *;\n\ndiv.lunchtime {\n    div.header {\n        margin: 0 auto;\n        max-width: 1440px;\n        height: 56px;\n        display: flex;\n        align-items: center;\n        border-bottom: 1px solid $light-gray;\n        padding: 10px;\n\n        span {\n            &.title {\n                font-size: 32px;\n                line-height: 32px;\n                font-weight: bold;\n                color: white;\n                background-color: $cv-red;\n                padding: 12px;\n                box-sizing: border-box;\n            }\n\n            &.spacer {\n                display: none;\n            }\n\n            &.subtitle {\n                font-size: 24px;\n                opacity: 0.7;\n                flex-grow: 1;\n                padding-left: 30px;\n                padding-top: 5px;\n            }\n\n            &.user {\n                font-size: 14px;\n                color: $dark-gray;\n            }\n        }\n    }\n\n    div.hero {\n        max-width: 1440px;\n        display: flex;\n        justify-content: space-around;\n        align-items: flex-start;\n        padding: 40px 0;\n        margin: 0 auto;\n\n        div.step {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            align-items: center;\n            width: 33%;\n            padding: 0 30px;\n\n            div.bubble {\n                height: 180px;\n                width: 180px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n\n                i.fa {\n                    color: $cv-red;\n                    font-size: 76px;\n                }\n            }\n\n            h2 {\n                color: $text-dark;\n                margin: 0 0 6px 0;\n                text-align: center;\n            }\n\n            article {\n                text-align: center;\n                width: 80%;\n                color: $dark-gray;\n                opacity: 0.8;\n            }\n        }\n    }\n\n    div.dates {\n        background-color: $dates-background;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 20px 0 60px 0;\n\n        h1.date-title {\n            color: $text-dark;\n            font-size: 40px;\n            font-weight: 200;\n            align-self: center;\n            opacity: 0.8;\n            margin: 0;\n            padding: 0;\n        }\n\n        h2.date-subtitle {\n            font-weight: 100;\n            margin: 0;\n            margin-bottom: 40px;\n            font-size: 22px;\n            opacity: 0.6;\n        }\n\n        div.appointments {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            div.appointment {\n                box-shadow: 0px 2px 0px 0px $light-gray;\n                border-radius: 30px;\n                height: 160px;\n                width: 200px;\n                margin: 0 20px;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                cursor: pointer;\n                padding-bottom: 6px;\n                background-color: white;\n                position: relative;\n\n                div.check {\n                    position: absolute;\n                    top: 39px;\n                    left: 0;\n                    background-color: white;\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 0 0 30px 30px;\n                    height: 127px;\n                    width: 100%;\n                    opacity: 0;\n\n                    span {\n                        color: black;\n                    }\n\n                    i.fa {\n                        font-size: 60px;\n                        line-height: 70px;\n                        color: $cv-grass-dark;\n                    }\n                }\n\n                span {\n                    font-size: 14px;\n                }\n\n                div.day {\n                    display: inline;\n                    width: 100%;\n                    background-color: $text-dark;\n                    color: white;\n                    padding: 10px 0;\n                    text-align: center;\n                    font-size: 14px;\n                    border-radius: 30px 30px 0 0;\n                }\n\n                div.combined {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: center;\n                    flex-grow: 1;\n\n                    span.big-number {\n                        color: $text-dark;\n                        font-size: 44px;\n                        line-height: 44px;\n                        font-weight: bold;\n                    }\n\n                    span.noon {\n                        opacity: 0.7;\n                    }\n                }\n\n                &.selected {\n                    background-color: $cv-grass-medium;\n                    color: white;\n\n                    div.combined {\n                        span.big-number {\n                            color: white;\n                        }\n                    }\n                }\n\n                &.isLocked {\n                    opacity: 0.4;\n                    cursor: default;\n\n                    &:hover {\n                        box-shadow: 0px 2px 0px 0px $light-gray;\n                    }\n                }\n\n                &:hover {\n                    box-shadow: 0px 8px 14px 2px $light-gray;\n                }\n            }\n        }\n    }\n\n    div.suggestions {\n        margin: 0 auto;\n        display: flex;\n        flex-direction: column;\n        padding: 20px 0;\n        margin-bottom: 20px;\n\n        h1 {\n            color: $text-dark;\n            font-size: 40px;\n            font-weight: 200;\n            align-self: center;\n            opacity: 0.8;\n            width: 570px;\n            text-align: center;\n        }\n\n        button {\n            align-self: center;\n            cursor: pointer;\n        }\n    }\n\n    div.footer {\n        background-color: $text-dark;\n        color: white;\n\n        div.links {\n            width: 80%;\n            padding: 20px;\n            box-sizing: border-box;\n            margin: 0 auto;\n            display: flex;\n            align-items: center;\n\n            h2 {\n                flex-grow: 1;\n            }\n\n            span {\n                margin: 0 10px;\n                opacity: 0.8;\n                font-size: 12px;\n                cursor: pointer;\n\n                &:hover {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}\n\n@media (max-width: 1024px), (orientation: portrait) {\n    div.modal {\n        display: none;\n    }\n\n    div.lunchtime {\n        div.header {\n            span.subtitle {\n                display: none;\n            }\n\n            span.spacer {\n                flex-grow: 1;\n                display: flex;\n            }\n        }\n\n        div.hero {\n            display: none;\n        }\n\n        div.dates {\n            padding-bottom: 40px;\n\n            div.appointments {\n                flex-direction: column;\n                justify-content: flex-start;\n\n                div.appointment {\n                    margin-bottom: 40px;\n                }\n            }\n        }\n\n        div.suggestions {\n            display: none;\n        }\n\n        div.footer {\n            div.links {\n                span {\n                    display: none;\n                }\n            }\n        }\n    }\n}\n","$text-dark: #444;\n\n$dark-gray: rgba(0,0,0,0.6);\n$light-gray: rgba(0,0,0,0.10);\n\n$dates-background: rgba(0,0,0,0.05);\n\n// cornelsen colors\n$cv-red: rgb(222,41,34);\n$cv-grass-dark: rgb(107,171,45);\n$cv-grass-medium: rgb(177,198,16);\n$cv-grass-light: rgb(220,235,205);\n$cv-sky-dark: rgb(0,148,170);\n$cv-sky-medium: rgb(109,186,210);\n$cv-sky-light: rgb(210,235,235);\n$cv-sand-dark: rgb(175,157,140);\n$cv-sand-medium: rgb(212,202,189);\n$cv-sand-light: rgb(240,230,225);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
